
import { Component, namespace, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import { getAnchorFromElement } from 'library/v4/components/OzPopoverModal.vue'
import OzDropdownButton, {
  OzDropdownButtonColorScheme,
  OzDropdownButtonSizePreset,
} from 'library/v4/components/OzDropdownButton.vue'
import type { PopoverAnchor } from 'types'
import LocaleMenu from 'vuecomponents/LocaleMenu.vue'

const localeStore = namespace('locale')
const browserStore = namespace('browser')

@Component({
  components: {
    OzIcon,
    OzDropdownButton,
    LocaleMenu,
  },
})
export default class LocaleSelectorVuex extends Vue {
  $refs!: {
    localeSelector: OzDropdownButton
  }

  OzDropdownButtonColorScheme = OzDropdownButtonColorScheme
  OzDropdownButtonSizePreset = OzDropdownButtonSizePreset
  menuAnchor: Partial<PopoverAnchor> = {}

  // This component comes as a pair with the vuexstore/modules/locale.ts.
  // Items from other parts of the vuex store should be passed in as props.
  @localeStore.State isSelectorOpen!: boolean
  @localeStore.State currentLocale!: string
  @localeStore.Getter currentLocaleName!: string
  @localeStore.Action openLocaleMenu!: () => void
  @localeStore.Action closeLocaleMenu!: () => void
  @localeStore.Action changeLocale!: (lang: string) => Promise<void>
  @browserStore.Getter isSmallerThanTabletPortrait!: number
  @browserStore.Getter windowHeight!: number

  mounted(): void {
    // Wait for the page fully rendered before calculating the menu anchor
    window.addEventListener('load', this.updateMenuAnchor)
  }

  openMenu(): void {
    this.updateMenuAnchor()
    this.openLocaleMenu()
  }

  updateMenuAnchor(): void {
    const localeSelector = this.$refs.localeSelector?.$el
    if (!localeSelector) return

    this.menuAnchor = getAnchorFromElement(localeSelector, { top: -4, left: -4 })
  }

  async handleChangeLocale(lang: string): Promise<void> {
    await this.changeLocale(lang)
    this.$emit('change')
  }
}
